// extracted by mini-css-extract-plugin
module.exports = {"legendItem":"LegendItem_legendItem__36WSX","fadeIn":"LegendItem_fadeIn__3pxZH","fadeOut":"LegendItem_fadeOut__2EFIj"};